import { atom, atomFamily, useRecoilValue, useSetRecoilState } from 'recoil';
import { RecoilKeys } from '../../interfaces';
import React from 'react';
import memoize from 'lodash/memoize';
export var gnbMobileOnlyToggleMenuButtonIsOpenAtomFamily = atomFamily({
    key: RecoilKeys.MobileOnlyGNBToggleMenuButtonIsOpen,
    default: false,
});
export var gnbSelectedMenuItem = atom({
    key: RecoilKeys.SelectedMenuItem,
    default: '',
});
export var gnbFooterCollapsibleMenuOpenWithGlobalKey = memoize(function (globalKey) {
    return atom({
        key: RecoilKeys.FooterCollapsibleMenuOpen + "_" + globalKey,
        default: false,
    });
});
/**
 * 사용하면 해당하는 OD_GLOBAL_KEY 의 메뉴 아이템이 선택상태가 된다.
 * 컴포넌트 unmount 시에 다시 원복된다.
 */
export function useGNBMenuSelect(globalKey) {
    var prev = useRecoilValue(gnbSelectedMenuItem);
    var setSelectedMenuItem = useSetRecoilState(gnbSelectedMenuItem);
    React.useEffect(function () {
        setSelectedMenuItem(globalKey);
        return function () { return setSelectedMenuItem(prev); };
    }, []);
}
//# sourceMappingURL=gnbCommon.js.map